<header
  class="flex justify-between px-16 h-56 md:px-24 xl:px-30 py-8 bg-white border-b border-secondary-100"
>
  <div class="flex sm:hidden w-full justify-between items-center">
    <ng-button variant="icon" icon="icon-menu" (click)="toggleNavbarState()" />

    <div class="flex items-center gap-8">
      <img
        alt="mobile-logo"
        class="mobile-logo"
        src="assets/img/logos/nav-logo-mobile.svg"
      />
    </div>
    <div class="flex items-center gap-12 ml-auto">
      @if (breakpoints.isMobile()) {
        <fc-quick-search />
      }
      <ng-button
        variant="tonal"
        (click)="openQuickCreationMenu()"
        size="sm"
        icon="icon-add"
        color="primary"
        iconPosition="only"
      >
      </ng-button>
      @if (currentEmployee()) {
        <fc-employee-menu />
      }
    </div>
  </div>

  <div
    class="hidden sm:grid xl:hidden grid-cols-[1fr_1fr_1fr] w-full justify-between items-center"
  >
    <div class="flex items-center gap-12">
      <ng-button
        variant="icon"
        icon="icon-menu"
        (click)="toggleNavbarState()"
      />

      <img
        [routerLink]="logoLink"
        class="pointer"
        src="assets/img/logos/nav-logo-mobile.svg"
        alt="desktop-logo"
      />
    </div>

    <div class="flex gap-12 items-center justify-center w-full">
      @if (breakpoints.isTablet()) {
        <fc-quick-search />
      }
      <ng-button
        variant="tonal"
        (click)="openQuickCreationMenu()"
        size="sm"
        icon="icon-add"
        [iconOnly]="true"
        color="primary"
      />
    </div>

    <div class="flex items-center gap-12 justify-end">
      <ng-button
        variant="icon"
        color="secondary"
        size="sm"
        [class.active]="showEvents()"
        (click)="openActivity()"
        icon="icon-notification-outline"
      />

      <div class="relative">
        <ng-button
          variant="icon"
          color="secondary"
          size="sm"
          [class.active]="showNews()"
          (click)="openNews()"
          icon="icon-news-outline"
        />
        @if (unreadNewsCount() > 0) {
          <div
            class="absolute right-6 top-6 z-10 size-12 rounded-full bg-primary-500"
          ></div>
        }
      </div>

      <ng-button
        variant="icon"
        (click)="openMobileHelp()"
        color="secondary"
        size="sm"
        [iconOnly]="true"
        icon="icon-help-outline"
      />

      @if (currentEmployee()) {
        <fc-employee-menu />
      }
    </div>
  </div>

  <div class="hidden xl:grid grid-cols-[1fr_1fr_1fr] w-full items-center">
    <div class="flex items-center gap-12">
      <img
        [routerLink]="logoLink"
        class="pointer max-h-36"
        src="assets/img/logos/nav-desktop-logo.svg"
        alt="desktop-logo"
      />
      @if (environment === 'staging') {
        <fc-ng-tag class="h-fit flex-1 block" color="primary">
          Staging
        </fc-ng-tag>
      }
      @if (environment === 'local') {
        <fc-ng-tag class="h-fit flex-1 block" color="warning">
          Local
        </fc-ng-tag>
      }
      @if (environment === 'test') {
        <fc-ng-tag class="h-fit flex-1 block" color="error"> Test </fc-ng-tag>
      }
    </div>

    <div class="flex gap-12 items-center justify-center w-full">
      @if (breakpoints.isDesktop()) {
        <fc-quick-search />
      }
      <fc-quick-creation-button />
    </div>

    <div class="flex items-center gap-12 justify-end">
      <ng-button
        variant="tonal"
        color="secondary"
        size="sm"
        [class.active]="showEvents()"
        (click)="openActivity()"
        icon="icon-notification-outline"
      >
        <div class="action-title">Activity</div>
      </ng-button>

      <div class="relative">
        <ng-button
          variant="tonal"
          color="secondary"
          size="sm"
          [class.active]="showNews()"
          (click)="openNews()"
          icon="icon-news-outline"
        >
          <div class="action-title">News</div>
        </ng-button>
        @if (unreadNewsCount() > 0) {
          <div
            class="absolute -right-4 -top-4 z-10 size-16 rounded-full bg-primary-500"
          ></div>
        }
      </div>

      <ng-button
        variant="tonal"
        (click)="openMobileHelp()"
        color="secondary"
        size="sm"
        icon="icon-help-outline"
      >
        <div class="action-title">Help</div>
      </ng-button>

      @if (filesUploadsService.hasActiveUploads()) {
        <ng-button variant="tonal" (click)="showUploads()" class="action-block">
          <div class="size-32 relative flex items-center justify-center">
            <fc-circular-progress
              [progress]="filesUploadsService.totalProgress()"
              circleColor="white"
            ></fc-circular-progress>
            <fc-icon
              [size]="12"
              class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
              color="white"
              icon="icon-arrow-up"
            ></fc-icon>
          </div>
        </ng-button>
      }

      @if (currentEmployee()) {
        <fc-employee-menu />
      }
    </div>
  </div>
</header>

@if (showNews()) {
  <fc-side-popup>
    <fc-news-tab (closePopup)="closeNews()"></fc-news-tab>
  </fc-side-popup>
  <div class="overlay" (click)="closeNews()"></div>
} @else if (showEvents()) {
  <fc-side-popup [showHeader]="false">
    <fc-events-tab (closePopup)="closeEvents()"></fc-events-tab>
  </fc-side-popup>
  <div class="overlay" (click)="closeEvents()"></div>
}
